import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Button } from '@/shared/ui/button';

export function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>404 - 페이지를 찾을 수 없습니다 | 동구바이오제약</title>
      </Helmet>
      <div className="flex h-screen flex-col items-center justify-center gap-4">
        <h1 className="text-4xl font-bold">404</h1>
        <p className="text-muted-foreground">페이지를 찾을 수 없습니다.</p>
        <Button asChild>
          <Link to="/">홈으로 돌아가기</Link>
        </Button>
      </div>
    </>
  );
}
